




























































































































































































































































































































































































import { Component, Vue, Provide, Watch, Prop } from "vue-property-decorator";
import {
  localGet,
  timeFormatDay,
  timeFormatSecond,
  timeFormat,
  setMetaData,
  downloadFile,
} from "@/utils/index";
@Component({
  name: "loanInfoMore",
  filters: {
    filterTime(time: number) {
      function addZero(val: any) {
        if (val < 10) {
          val = "0" + val;
        }
        return val;
      }
      if (!time) {
        return time;
      }
      let date: any = new Date(time);
      let month: any = addZero(date.getMonth() + 1);
      let day: any = addZero(date.getDate());
      var yearMonthDay = date.getFullYear() + "-" + month + "-" + day;
      var hoursMS =
        addZero(date.getHours()) +
        ":" +
        addZero(date.getMinutes()) +
        ":" +
        addZero(date.getSeconds());
      return yearMonthDay + " " + hoursMS;
    },
  },
})
export default class loanInfoMore extends Vue {
  @Prop() orderStatus: any;
  @Prop() isBadDebts: any;
  @Prop() borrowCode: any;
  @Prop() onCopy: any;
  @Prop() onError: any;
  @Prop() ticketData: any;
  @Prop() repaymentDate: any;
  @Prop() repaymentMoney: any;
  @Prop() overdueDays: any;
  @Prop() hasRepaymentMoney: any;
  @Prop() billAllMoney: any;
  @Prop() extitemList: any;
  @Prop() repayInfo: any;
  @Prop() isShowLetter: any;
  @Prop() querytype: any;
  @Prop() country: any;
  @Prop() warningLetterList: any;
  @Prop() isdownUrgeLetterDone: any;
  @Prop() applyDeferPeriodText: any;
  @Prop() deferPeriodStatus: any;
  @Prop() loaninfolistList: any;

  @Prop() caselevel: any;
  @Provide() private isUrgeLetterListDone: boolean = false; // 是否获取过下载催收函
  //   @Provide() isUrgeLetterListDone: any;

  @Provide() urgeLetterId: any = ""; // 催收函id
  @Provide() urgeLetterList: any = ""; // 催收函id
  //   @Provide() : boolean = false;

  private showDiffTypeDialog(
    type: any,
    orderid: any,
    rollDeferPeriodStatus?: any,
    rollinfolistList?: any
  ) {
    console.log(type, orderid, rollDeferPeriodStatus, rollinfolistList);

    this.$emit(
      "showDiffTypeDialog",
      type,
      orderid,
      rollDeferPeriodStatus,
      rollinfolistList
    );
  }
  //下載
  private downloadUrgeLetter(val: any, letter: any) {
    this.$emit("downloadUrgeLetter", {
      item: PointerEvent,
      val: val,
      letter: letter,
    });
  }
  //  下载警告信列表
  private downloadWarningLetter(item: any) {
    this.$emit("downloadWarningLetter", {
      item: item,
      //   val: this.urgeLetterId,
    });
  }
  //  发送警告信列表
  private sendWarningLetter(item: any) {
    this.$emit("sendWarningLetter", {
      item: item,
      //   val: this.urgeLetterId,
    });
  }
  // 切换催收函模板
  private getUrgeLetterOptions(val: any) {
    console.log(val);

    if (!this.isUrgeLetterListDone) {
      this.getUrgeLetterMap(val);
      this.isUrgeLetterListDone = true;
    }
  }
  // 获取催收函列表
  private async getUrgeLetterMap(val: any) {
    const {
      getUrgeLetterMapReqRequest,
      getUrgeLetterMapReq,
    }: any = await import("@/request/urgeLetter");
    let res: any = await getUrgeLetterMapReqRequest.handleHttp(
      getUrgeLetterMapReq({
        Caselevel: this.caselevel,
        Orderid: val, //this.ticketData.orderid,
      }),
      this
    );
    if (res) {
      // this.urgeLetterList1=res.urgelettermapMap
      this.urgeLetterList = res.urgelettermapMap;
    }
    console.log(res, "getUrgeLetterMapReqRequest---------------------------");
  }
}
